import React, { forwardRef } from "react"
import styled from "@emotion/styled"
import { Text } from "theme-ui"
import FreeShippingBar from "../free-shipping-bar"

const BannerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.darkerGreen};
  color: ${(props) => props.theme.colors.white};
  text-align: center;
  padding: 10px 15px;
  ${({ theme }) => theme.bp.largeDesktop} {
    padding: 8px 30px;
  }
  font-family: ${({ theme }) => theme.fonts.body};

  z-index: 1000;
  font-size: ${({ theme }) => theme.fontSizes[0]}px;
  ${({ theme }) => theme.bp.largeDesktop} {
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
  }
`

const Banner = forwardRef((_, ref) => {
  return (
    <BannerContainer ref={ref}>
      <Text>
        <FreeShippingBar />
      </Text>
    </BannerContainer>
  )
})

Banner.displayName = "Banner"

export default Banner
